/**
 * TagsView（页签栏）持久化存储。
 *
 * 采用 sessionStorage：会话级存储，F5 刷新保留页签，关闭浏览器标签页自动清空，
 * 跨浏览器标签页互不影响（避免多开标签页互相串页签）。
 *
 * 仅持久化标签元数据（key/label/path/closable），不持久化渲染内容——
 * 刷新后各页签由 TabLayout 的自研 keep-alive 按当前 location 重新挂载。
 *
 * 统一收口读写与清理入口，供 TabLayout 与各登出路径复用，避免 key 散落多处。
 */

export const TAGSVIEW_STORAGE_KEY = 'tagsview_tabs';

/** 读取已持久化的页签栏元数据（解析失败或结构异常时返回空数组）。 */
export function loadTagsViewTabs<T = any>(): T[] {
  try {
    const raw = sessionStorage.getItem(TAGSVIEW_STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (t) => t && typeof t.path === 'string' && typeof t.key === 'string',
    ) as T[];
  } catch {
    return [];
  }
}

/** 写入页签栏元数据。 */
export function saveTagsViewTabs(tabs: unknown[]): void {
  try {
    sessionStorage.setItem(TAGSVIEW_STORAGE_KEY, JSON.stringify(tabs));
  } catch {
    /* sessionStorage 不可用时降级为内存态（刷新即丢），不影响主流程 */
  }
}

/** 清空页签栏持久化数据（登出 / 进入登录页 / 强制改密后调用）。 */
export function clearTagsViewTabs(): void {
  try {
    sessionStorage.removeItem(TAGSVIEW_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
